import * as LEAD_ from "store/constants/lead";

export const leadsCreateRequest = (payload) => ({
  type: LEAD_.LEADS_CREATE,
  payload,
});
